export default __webpack_public_path__ + "static/android-chrome-512x512-68f664f67b3bc1c83d39601d68829e50.png";